
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import {
    AccountConfirmation,
    CreateLicenseCommand,
    LicenseCommandBase,
    LicenseDto,
    UpdateLicenseCommand
  } from '@/apiclient/apiclient_generated';
  import { LicenseModule, LicenseStore } from '@/store/license';
  import { AccountModule, AccountStore } from '@/store/account';

  @Options({})
  export default class CreateUpdateLicense extends Vue {
    private licenseStore: LicenseModule = LicenseStore;
    private accountStore: AccountModule = AccountStore;

    @Prop() license: LicenseDto;
    @Prop() account: number;

    productId = null;
    password = '';
    isLoading = false;

    LicenseConfirmations = [AccountConfirmation.None, AccountConfirmation.Mail, AccountConfirmation.MailWithCredentials];

    get modalHeader() {
      return this.license.id ? 'Modify License' : 'Create License';
    }

    get availableProducts() {
      return this.licenseStore.availableProducts;
    }

    get availableLicenseTypes() {
      return this.licenseStore.licenseTypes;
    }

    get isFormValid() {
      return (
        this.license.product &&
        this.license.type &&
        this.license.maximumActivations &&
        this.license.expiredDays &&
        this.license.expiryDate &&
        !this.isLoading
      );
    }

    async mounted() {
      await this.licenseStore.getAvailableProducts();

      await this.licenseStore.getAvailableLicenseTypes();

      if (!this.license.id) {
        this.license.product = this.availableProducts[0].name;
        this.license.type = this.availableLicenseTypes[0].name;

        this.license.maximumActivations = 1;
        this.license.expiredDays = 30;
        this.updateExpiryDate();
      }
    }

    private updateExpiryDays(newExpiryDate) {
      if (!newExpiryDate) {
        this.license.expiredDays = null;
        return;
      }

      newExpiryDate = this.getDefaultDate(newExpiryDate);
      this.license.expiryDate = newExpiryDate;

      const date: any = this.license.createdDate || this.getDefaultDate();

      const newExpiryDateOffset = newExpiryDate.getTimezoneOffset();
      const nowDateOffset = date.getTimezoneOffset();

      var diff = Math.abs(newExpiryDate.getTime() - date.getTime());
      var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

      // if (Math.abs(nowDateOffset - newExpiryDateOffset) !== 0) {
      //   --diffDays;
      // }

      this.license.expiredDays = diffDays;
    }

    private getDefaultDate(date = new Date()) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);

      return date;
    }

    private updateExpiryDate() {
      const daysToAdd = +this.license.expiredDays;

      const date: any = this.license.createdDate || this.getDefaultDate();
      date.setDate(date.getDate() + daysToAdd);

      this.license.expiryDate = date;
    }

    processExpiredDaysChange() {
      this.updateExpiryDate();
    }

    async submitCreateUpdateForm() {
      this.isLoading = true;
      if (this.license.id) {
        await this.processUpdate();
      } else {
        await this.processCreate();
      }
    }

    async processCreate() {
      const command = this.map<CreateLicenseCommand>(this.license);
      command.productName = this.license.product;

      const result = await this.licenseStore.createLicense(command);

      this.processResult(result);
    }

    async processUpdate() {
      const command = this.map<UpdateLicenseCommand>(this.license);
      command.licenseId = this.license.id;

      const result = await this.licenseStore.updateLicense(command);

      this.processResult(result);
    }

    cancelCreateUpdateForm() {
      this.$emit('cancel');
    }

    get isCurrentFormValid() {
      return false;
    }

    private map<T extends LicenseCommandBase>(license: LicenseDto) {
      return {
        licenseType: license.type,
        expiredDays: license.expiredDays,
        maximumActivations: license.maximumActivations,
        expiryDate: license.expiryDate,
        accountId: this.account,
        licenseDomain: license.licenseDomain
      } as T;
    }

    private processResult(result) {
      this.isLoading = false;

      if (result.isSuccess) {
        this.$emit('save');
      }
    }
  }
